import { UPDATE_IOU_COUNT } from '../actions/UpdateIouCount';

const initialState = {
  iouCount: 0,
};

const iouReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_IOU_COUNT:
      return {
        ...state,
        iouCount: action.payload,
      };
    default:
      return state;
  }
};

export default iouReducer;